<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="$t('sales.clientsList.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <vue-json-to-csv :json-data="docToExport" :csv-title="`Ingressos y documentos (${computedDateFormatted})`"
                :separator="';'" :labels="csvLabels">
                <v-btn outlined color="primary" height="40" class="ml-2">
                    {{ $t("common.export") }}

                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </vue-json-to-csv>
        </div>
        <v-card outlined>
            <v-data-table :loading="loading" :headers="headers" :items="documents" :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 25, 50]
            }" :items-per-page="25" :search="search">
            <template v-slot:[`item.id`]="{ item }">
                    <v-img height="40" width="40" cover :src="item.logo"></v-img>
                    
                </template>
                <template v-slot:[`item.master`]="{ item }">
                    <v-chip v-if="item.master" color="primary">Principal</v-chip>
                    <v-chip v-if="!item.master" outlined color="primary">Subloja</v-chip>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <v-chip v-if="item.status == 'published'" color="success">Ativa</v-chip>
                    <v-chip v-else color="error">Inativa</v-chip>
                </template>
                <template v-slot:[`item.updatedOn`]="{ item }">
                    {{ item.updatedOn | dateTime }}
                </template>
                <template v-slot:[`item.createdOn`]="{ item }">
                    <v-chip v-if="item.piInfo && item.piInfo.address && item.piInfo.cnpj && item.piInfo.receiver && item.piInfo.commRatio" color="success">Completa</v-chip>
                    <v-chip v-else color="error">Com pendências</v-chip>
                </template>
                <template v-slot:[`item.options`]="{ item }">
                    <v-btn elevation="0" icon @click="edit(item)" color="primary"><v-icon>mdi-pencil</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-card>
    </v-card>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import VueJsonToCsv from "vue-json-to-csv";
import { initializeApp } from "firebase/app";

import { getFirestore, collection, query, where, getDocs, setDoc, doc, deleteDoc } from "firebase/firestore";
export default {
    name: 'BillingTable',
    components: {
        VueJsonToCsv
    },
    data() {
        return {
            documents: [],
            loading: true,
            search: this.$route.query.q ? this.$route.query.q : "",
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                { text: 'Nome da loja', value: 'name' },
                { ztext: 'Tipo', value: 'master' },
                { text: 'Status da loja', value: 'status' },
                { text: 'Pendências da loja', value: 'createdOn' },
                { text: 'Última atualização', value: 'updatedOn' },
                { text: '', align: 'end', value: 'options' },
            ]
        }
    },
    mounted() {
        this.loadDocuments()
    },

    methods: {
        loadDocuments() {
            this.loading = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const q = query(collection(db, "stores"));
            const querySnapshot = getDocs(q);
            const documents = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    const data = doc.data()
                    documents.push(data)

                })
                this.documents = documents
                this.loading = false
            })
        },
    }
}

</script>